import { PageLocatorMap } from '../types/PageLocatorMap';

export const coapplicantPreviousResidencePage = {
  alert: {
    error: 'coapplicant-previous-residence-page.alert.error',
  },
  footer: {
    root: 'coapplicant-previous-residence-page.footer.root',
  },
  form: {
    addressLine1Input:
      'coapplicant-previous-residence-page.form.address-line-1-input',
    addressLine1InputError:
      'coapplicant-previous-residence-page.form.address-line-1-input-error',
    addressLine2Input:
      'coapplicant-previous-residence-page.form.address-line-2-input',
    cityInput: 'coapplicant-previous-residence-page.form.city-input',
    cityInputError: 'coapplicant-previous-residence-page.form.city-input-error',
    h1: 'coapplicant-previous-residence-page.form.h1',
    h2: 'coapplicant-previous-residence-page.form.h2',
    root: 'coapplicant-previous-residence-page.form.root',
    stateSelect: 'coapplicant-previous-residence-page.form.state-select',
    stateSelectError:
      'coapplicant-previous-residence-page.form.state-select-error',
    submitButton: 'coapplicant-previous-residence-page.form.submit-button',
    zipCodeInput: 'coapplicant-previous-residence-page.form.zip-code-input',
    zipCodeInputError:
      'coapplicant-previous-residence-page.form.zip-code-input-error',
  },
} as const satisfies PageLocatorMap;
